module.exports = __webpack_public_path__ + "static/media/floor-1-error.87865be9.jpg";